var UitkLayoutSpaceMap = [
    ['half', 'gap-half'],
    ['one', 'gap-one'],
    ['two', 'gap-two'],
    ['three', 'gap-three'],
    ['four', 'gap-four'],
    ['six', 'gap-six'],
    ['twelve', 'gap-twelve'],
    ['xsmall', 'gap-xsmall'],
    ['small', 'gap-small'],
    ['medium', 'gap-medium'],
    ['large', 'gap-large'],
    ['xlarge', 'gap-xlarge']
];
var UitkLayoutSpaces = new Map(UitkLayoutSpaceMap);
var UitkLayoutFixedSizeMap = [
    ['zero', 'zero'],
    ['fifteen', 'fifteen'],
    ['sixteen', 'sixteen'],
    ['twenty_four', 'twenty_four'],
    ['seventy_two', 'seventy_two'],
    ['seventy_six', 'seventy_six'],
    ['eighty_eight', 'eighty_eight'],
    ['ninety_six', 'ninety_six'],
    ['one_hundred_four', 'one_hundred_four'],
    ['one_hundred_twelve', 'one_hundred_twelve'],
    ['one_hundred_twenty', 'one_hundred_twenty']
];
var UitkLayoutFixedSizes = new Map(UitkLayoutFixedSizeMap);
var UitkLayoutPercentageSizeMap = [
    ['full_width', 'full_width'],
    ['half_width', 'half_width'],
    ['third_width', 'third_width'],
    ['quarter_width', 'quarter_width']
];
var UitkLayoutPercentageSizes = new Map(UitkLayoutPercentageSizeMap);
// To be deprecated
var UitkLayoutSizeMap = [
    ['zero', 'zero'],
    ['fifteen', 'fifteen'],
    ['sixteen', 'sixteen'],
    ['twenty_four', 'twenty_four'],
    ['seventy_two', 'seventy_two'],
    ['seventy_six', 'seventy_six'],
    ['eighty_eight', 'eighty_eight'],
    ['ninety_six', 'ninety_six'],
    ['one_hundred_four', 'one_hundred_four'],
    ['one_hundred_twelve', 'one_hundred_twelve'],
    ['one_hundred_twenty', 'one_hundred_twenty'],
    ['full_width', 'full_width'],
    ['half_width', 'half_width'],
    ['third_width', 'third_width'],
    ['quarter_width', 'quarter_width']
];
var UitkLayoutSizes = new Map(UitkLayoutSizeMap);
var UitkLayoutTagMap = [
    ['article', 'article'],
    ['aside', 'aside'],
    ['div', 'div'],
    ['footer', 'footer'],
    ['header', 'header'],
    ['section', 'section'],
    ['ul', 'ul'],
    ['ol', 'ol'],
    ['li', 'li'],
    ['main', 'main']
];
var UitkLayoutTags = new Map(UitkLayoutTagMap);

export { UitkLayoutFixedSizes, UitkLayoutPercentageSizes, UitkLayoutSizes, UitkLayoutSpaces, UitkLayoutTags };
